module.exports = __webpack_public_path__ + "static/media/blog8-image.05d76fbe.jpg";